(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("smart-path-resolver", [], factory);
	else if(typeof exports === 'object')
		exports["smart-path-resolver"] = factory();
	else
		root["smart-path-resolver"] = factory();
})(this, () => {
return 